import { z } from 'zod';

import { paginationQuerySchema } from './pagination.js';

export const auditEntryDtoSchema = z.object({
  id: z.string(),
  actor: z.string(),
  action: z.string(),
  entity: z.string(),
  entityId: z.string().nullable(),
  before: z.record(z.unknown()).nullable(),
  after: z.record(z.unknown()).nullable(),
  createdAt: z.string().datetime(),
});
export type AuditEntryDto = z.infer<typeof auditEntryDtoSchema>;

export const listAuditQuerySchema = paginationQuerySchema.extend({
  actor: z.string().trim().optional(),
  action: z.string().trim().optional(),
  entity: z.string().trim().optional(),
});

export const settingsDtoSchema = z.object({
  retentionDays: z.number().int(),
  alertEmails: z.array(z.string().email()),
  alertWebhookUrl: z.string().url().nullable(),
  sendAllowlist: z.array(z.string()),
  brandName: z.string(),
});
export type SettingsDto = z.infer<typeof settingsDtoSchema>;

export const updateSettingsSchema = z
  .object({
    retentionDays: z.number().int().min(7).max(3650).optional(),
    alertEmails: z.array(z.string().email()).max(20).optional(),
    alertWebhookUrl: z.string().url().nullable().optional(),
  })
  .strict();
